$(document).ready(function() {
	TweenMax.staggerFrom(
		".js-stagger",
		1.2,
		{
			y: 80,
			ease: Power4.easeOut,
			onComplete: function() {
				
				if (this.target.classList.contains('js-animated')) {
					this.target.classList.add("title--underline");
				}
			}
		},
		0.1
	);
});
